import { Button, Modal } from 'antd';
import { useState } from 'react';

export const FeatureModal = params => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <Button
        type='default'
        onClick={showModal}
        size='small'
        style={{ width: '100%', position: 'relative' }}
        disabled={params.device_id ? false : true}
      >
        Свойства
      </Button>
      <Modal
        title={`Информация об устройстве ${params.device_id}`}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        cancelText='Отмена'
      >
        <p>Информация об устройстве</p>
        <p>{`id: ${params.id}`}</p>
        <p>{`Android id: ${params.device_id ? params.device_id : 'Отсутствует'}`}</p>
        <p>{`Пароль: ${params.password ? params.password : 'Отсутствует'}`}</p>
        <p>{`Позывной: ${params.call_sign ? params.call_sign : 'Отсутствует'}`}</p>
        <p>{`Военная часть: ${params.army_post ? params.army_post : 'Отсутствует'}`}</p>
        <p>{`Тип устройства: ${params.type ? params.type : 'Отсутствует'}`}</p>
        <p>{`Телеграмм: ${params.tg ? params.tg : 'Отсутствует'}`}</p>
        <p>{`Серия: ${params.serial ? params.serial : 'Отсутствует'}`}</p>
      </Modal>
    </>
  );
};
